module.exports = __webpack_public_path__ + "static/key-wargroove-3fe8c131dc8f1dcd822c74c52674921d.webp";